import { isEmptyAndBlank } from 'utils/common/StringUtils';
export const isEmptySelect = value => {
  return isEmptyAndBlank(value) ? false : true;
};
